import { render } from "./Loading.vue?vue&type=template&id=4ac91fa5"
const script = {}
script.render = render

export default script